app.service('errorService', function (focus, modalErrorService) {

    this.processError = function (response, options) {
        var obj = response;

        var errors = "";

        //Foundation Messages
        if (obj.data != null && obj.data.Messages != null) {
            var data = obj.data;
            var firstFocus = "";
            for (var i = 0; i < data.Messages.length; i++) {
                if (firstFocus == '') {
                    firstFocus = data.Messages[i].Field;
                }
                errors += "<li>" + substituirMensagemErroAA(data.Messages[i].Description) + "</li>";
            }

            if (firstFocus != '') {
                focus(firstFocus);
            }
        }
        else {
            //WebApi Messages
            if (obj.data != null && obj.config != null && obj.statusText != null) {
                errors += "<li>Método +" + obj.config.url + " (" + obj.statusText + " [" + obj.status + "])" + "</li>";
                errors += "<li>" + substituirMensagemErroAA(obj.data.Message) + "</li>";
            }
        }


        if (errors != '') {
            errors = "<ul style='margin-bottom:10px'>" + errors + "</ul>";
            modalErrorService.showModal({}, {}, errors);
        }

        if (options != null) {
            options.success({ Data: [], Count: 0, Errors: null });
        }

    };

});
